const getCJDropshippingNavigation = (t, { isFamily = false, isCJConnected = false } = {}) => [
  { to: "/dropshipping/platforms", label: t("h_cj_nav_platforms", "Platforms") },
  // Once the seller has an active CJ connection, the account-creation/signup
  // flow no longer applies -- only surface it while still onboarding.
  ...(isCJConnected ? [] : [
    { to: "/dropshipping/cj", label: t("h_cj_nav_cj", "CJ Dropshipping") },
    { to: "/dropshipping/cj/signup", label: t("h_cj_nav_signup", "Signup") },
  ]),
  { to: "/dropshipping/connection", label: t("h_cj_nav_connection", "API Connection") },
  { to: "/dropshipping/categories", label: t("h_cj_nav_categories", "Categories") },
  { to: "/dropshipping/suppliers", label: t("h_cj_nav_suppliers", "Suppliers") },
  { to: "/dropshipping/products", label: t("h_cj_nav_products", "Products") },
  { to: "/dropshipping/imported", label: t("h_cj_nav_imported", "Imported Products") },
  { to: "/dropshipping/orders", label: t("h_cj_nav_orders", "Orders") },
  { to: "/dropshipping/sync", label: t("h_cj_nav_sync", "Sync") },
  { to: "/dropshipping/errors", label: t("h_cj_nav_errors", "API Errors") },
  ...(isFamily ? [{ to: "/dropshipping/admin", label: t("h_cj_nav_admin", "Administration") }] : []),
];

module.exports = { getCJDropshippingNavigation };
